import React from 'react';
import { useLcaDiagram, useProductImpacts } from '../hooks';
import { useParams } from 'react-router-dom';
import { parseNumericId } from 'src/utils/navigation';
import ImpactGridTable from './ImpactGridTable';
import { StyledPanel } from '../styles';
import { StyledTitle } from './styles';
import { useTranslation } from 'react-i18next';

export default function ImpactGrid() {
  const { t } = useTranslation('lca', { keyPrefix: 'impactGrid' });
  const { id } = useParams();
  const productId = parseNumericId(id);
  const { data: diagramData } = useLcaDiagram(productId);
  const { data: impactData } = useProductImpacts(productId);

  return (
    <StyledPanel>
      <StyledTitle>{t('title')}</StyledTitle>
      <br />
      <ImpactGridTable
        diagramData={diagramData}
        impactData={impactData}
        showSummaryRows
      />
    </StyledPanel>
  );
}
